import { render } from "./Header.vue?vue&type=template&id=78c322dd&scoped=true"
import script from "./Header.vue?vue&type=script&setup=true&lang=js"
export * from "./Header.vue?vue&type=script&setup=true&lang=js"

import "./Header.vue?vue&type=style&index=0&id=78c322dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c322dd"],['__file',"src/layouts/inc/Header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78c322dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78c322dd', __exports__)) {
    api.reload('78c322dd', __exports__)
  }
  
  module.hot.accept("./Header.vue?vue&type=template&id=78c322dd&scoped=true", () => {
    api.rerender('78c322dd', render)
  })

}


export default __exports__